import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/new_ui/Modal/Modal';

import { Button } from 'react-bootstrap5';

import { useNavigate, useParams, useLocation } from 'react-router-dom';

import confirmAlert from 'components/new_ui/Alerts/confirm';

import Actions from 'components/Members/Schedule/Actions';
import confirmWithoutCancel from 'components/new_ui/Alerts/confirmWithoutCancel';

import routes from 'app/routes';

import BlockedReason from './BlockedReason';

export default function Index({ refreshParent }) {
  const navigate = useNavigate();

  const { state } = useLocation();

  const isPossibleSkip = state?.isPossibleSkip || false;
  const isScheduleSessionPage = state?.isScheduleSessionPage || false;
  const reason = state?.reason || 'credits';

  const { stepId } = useParams();

  const returnBack = () => {
    if (isScheduleSessionPage) {
      document.location.href = routes.members.programs.index;
    } else {
      navigate(-1);
    }
  };

  const onBuySessionClick = () => {
    document.location.href = '/members/wallet';
  };

  const onSkipStepClick = () => {
    confirmAlert({
      title: 'Skip Session',
      text: 'Are you sure you would like to skip this step? This action can not be undone.',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }, () => {
      Actions.skipSession(stepId, () => {
        confirmWithoutCancel({
          text: 'Session successfully skipped!',
        }, () => {
          refreshParent();
          returnBack();
        });
      }, (data) => {
        if (data.errors) {
          confirmWithoutCancel({
            text: data.errors[0].title,
          });
        }
      });
    });
  };

  if (reason === 'blocked') {
    return <BlockedReason returnBack={returnBack} />;
  }

  return (
    <Modal
      header={
        <h3>We Can&apos;t Schedule This Session...Yet!</h3>
      }
      size="lg"
      show
      onHide={returnBack}
    >

      <p>
        Looks like you don&apos;t have any coaching credits! But that&apos;s okay.
      </p>
      <p>
        Simply click &quot;Buy a New Session&quot; below to start or continue your coaching program.
      </p>

      <footer className="d-flex justify-content-between">
        <div>
          {isPossibleSkip && <Button onClick={onSkipStepClick} variant="outline-primary">Skip Session</Button>}
        </div>
        <div>
          <Button variant="outline-primary" onClick={returnBack}>Remind Me Later</Button>
          <Button onClick={onBuySessionClick}>Buy a New Session</Button>
        </div>
      </footer>

    </Modal>
  );
}

Index.propTypes = {
  refreshParent: PropTypes.func,
};

Index.defaultProps = {
  refreshParent: () => {},
};
